import { IconAILabelOutline } from '../../icon/IconAILabelOutline';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { ICON_HEIGHT, ICON_WIDTH } from './constants';
import { PostAILabelProps } from './types';

export const PostAILabel: React.FC<PostAILabelProps> = ({
    text,
    iconHeight = ICON_HEIGHT,
    iconWidth = ICON_WIDTH,
    ...other
}) => (
    <Flex direction="row" justifyContent="center" spacing={1} {...other}>
        <IconAILabelOutline width={iconWidth} height={iconHeight} color="var(--color-secondary)" />
        <Typography variant="caption" weight="regular" color="secondary">
            {text}
        </Typography>
    </Flex>
);
